module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter01"
    }
  }, [_vm._v("Chapter One"), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Leibstandarte SS Adolf Hitler (LSSAH)")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter02"
    }
  }, [_vm._v("Chapter Two"), _c('span', {
    staticClass: "space2"
  }, [_vm._v("Joachim Peiper – Early life")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three"), _c('span', {
    staticClass: "space3"
  }, [_vm._v("Peiper’s Killings – 1943")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four"), _c('span', {
    staticClass: "space4"
  }, [_vm._v("Boves Massacre")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five"), _c('span', {
    staticClass: "space5"
  }, [_vm._v("The Ardenne Abbey Massacre")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six"), _c('span', {
    staticClass: "space6"
  }, [_vm._v("The Malmedy Massacres")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven"), _c('span', {
    staticClass: "space7"
  }, [_vm._v("The Wereth Massacre")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight"), _c('span', {
    staticClass: "space8"
  }, [_vm._v("Malmedy Massacre: Arrest, Trial and Conviction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine"), _c('span', {
    staticClass: "space9"
  }, [_vm._v("Peiper’s Interview: 7 September 1945")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten"), _c('span', {
    staticClass: "space10"
  }, [_vm._v("Peiper’s Trial")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven"), _c('span', {
    staticClass: "space11"
  }, [_vm._v("Prosecution Witnesses")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve"), _c('span', {
    staticClass: "space12"
  }, [_vm._v("Letter from Landsberg")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen"), _c('span', {
    staticClass: "space13"
  }, [_vm._v("Peiper’s Life After Release")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen"), _c('span', {
    staticClass: "space14"
  }, [_vm._v("Peiper’s Death")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen"), _c('span', {
    staticClass: "space15"
  }, [_vm._v("US Senate Committee Hearing on Armed Services, 1949")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen"), _c('span', {
    staticClass: "space16"
  }, [_vm._v("What the Papers Said")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Bibligraphy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author Biography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13c59a56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0